import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";
import { translate } from "react-i18next";

class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { t, open, handleClose, file, confirm } = this.props;
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t("confirm")}</DialogTitle>
        <DialogContent>
          {file && (
            <DialogContentText id="alert-dialog-description">
              {t("confirm_delete_message")} <b>{file.name}</b>?
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("cancel")}
          </Button>
          <Button
            onClick={async () => {
              await confirm();
              await handleClose();
            }}
            color="secondary"
            autoFocus
          >
            {t("confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default translate("translations")(ConfirmDialog);
